import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { UserRepository } from '@/store/user-state/user-state.repository';

interface getUserDataTableStructureProps {
  store: UserRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getUserDataTableStructure = ({ store, createAction, rowActions }: getUserDataTableStructureProps): DynamicDataTable => {
  const usernameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.username',
    accessorKey: 'username',
    variant: DataTableColumnVariant.TEXT,
  };
  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.firstName',
    accessorKey: 'firstName',
    variant: DataTableColumnVariant.TEXT,
  };
  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.lastName',
    accessorKey: 'lastName',
    variant: DataTableColumnVariant.TEXT,
  };
  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };
  const enabledColumn: DynamicDataTableColumn<any> = {
    label: 'settings.userInfo.table.enabled',
    accessorKey: 'enabled',
    variant: DataTableColumnVariant.SWITCH,
    renderAs: (value: boolean) => ({ value }),
    props: {
      onChange: (checked: boolean, value: any, row: any) => {
        if (typeof (store as any).enableUserSwitchHandler === 'function') {
          (store as any).enableUserSwitchHandler(checked, row);
        }
      },
    },
  };
  return {
    singular: 'settings.userInfo.table.singular',
    plural: 'settings.userInfo.table.plural',
    columns: [usernameColumn, firstNameColumn, lastNameColumn, emailColumn, enabledColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: any) => {
      store.set('dto', {
        id: row.id,
        username: row.username,
        firstName: row.firstName,
        lastName: row.lastName,
        email: row.email,
        enabled: row.enabled,
        emailVerified: row.emailVerified,
        roles: row.roles,
      });
      store.set('response', row);
    },
    createAction,
    rowActions,
    searchableFields: ['username', 'firstName', 'lastName', 'email'],
  };
};
